import "./App.css"
// import jobaffinity from "./jobaffinity.json"
import moment from "moment"
import React, { useEffect, useState } from "react"
import Job from "./components/Job"
import SearchFilters from "./components/SearchFilters"
import SearchResults from "./components/SearchResults"

const DEPART_IDF = {
    75: "75 - Paris",
    // 77: "77 - Seine-et-Marne",
    78: "78 - Yvelines",
    91: "91 - Essonne",
    92: "92 - Hauts-de-Seine",
    93: "93 - Seine Saint-Denis",
    94: "94 - Val-de-Marne",
    95: "95 - Val-d'Oise",
}

let { offre_id, jobaffinity } = window
let filters = getFilters(jobaffinity.jobs)
let firstJob = null
let firstSimilarJobs = []
if (offre_id) {
    jobaffinity.jobs.map((j) => {
        if (j.id == offre_id) {
            firstJob = j
            firstSimilarJobs = getSimilarJob(j)
        }
    })
}

function exergue(html) {
    var tmp = document.createElement("DIV")
    tmp.innerHTML = html
    let res = tmp.textContent || tmp.innerText || ""
    return res
}

function optionCompare(a, b) {
    if (a.label < b.label) {
        return -1
    }
    if (a.label > b.label) {
        return 1
    }
    return 0
}

function publicationDateCompare(a, b) {
    if (a.last_publication_date.isBefore(b.last_publication_date)) {
        return 1
    }
    if (a.last_publication_date.isAfter(b.last_publication_date)) {
        return -1
    }
    return 0
}

function createOption(label) {
    return {
        label,
        value: label,
    }
}

function getFilters(jobs) {
    let typeContratTmp = []
    let typeContrat = []
    let metierTmp = [
        "Assurance",
        "Back Office des opérations bancaires",
        "Banque Privée",
        "Banque - marché des entreprises",
        "Banque - marché des particuliers",
        "Banque - marché des pro, agri",
        "Finance / Comptabilité / Contrôle de gestion / trésorerie",
        "Immobilier",
        "Informatique / réseaux",
        "Logistique / achats",
        "Marketing / communication",
        "Organisation / qualité",
        "Ressources Humaines",
        "Risque / audit / juridique / contentieux",
    ]
    let metier = []
    metierTmp.map((e) => {
        metier.push(createOption(e))
    })
    let localisationTmp = [
        "75 - Paris",
        "Paris - 12 ème (Siège social)",
        // "77 - Seine-et-Marne",
        "78 - Yvelines",
        "91 - Essonne",
        "92 - Hauts-de-Seine",
        "93 - Seine Saint-Denis",
        "94 - Val-de-Marne",
        "95 - Val-d'Oise",
    ]
    let localisation = []
    localisationTmp.map((e) => {
        localisation.push(createOption(e))
    })

    jobs.map((j) => {
        j.exergue = exergue(j.position_description)
        j.localisation = "Ile-de-France"
        j.attributes.map((a) => {
            if (a.name === "type_de_poste") {
                j.type_de_poste = a.value
            } else if (a.name === "reseau_d'agence_ou_siege") {
                j.reseau_agence_ou_siege = a.value
            } else if (a.name === "localisation") {
                j.localisation = DEPART_IDF[a.value] ? DEPART_IDF[a.value] : a.value
            } else if (a.name === "categorisation_pour_tag") {
                j.categorisation_pour_tag = a.value
            }
        })
        j.isSiegeSocial = j.reseau_agence_ou_siege == "Siège"

        j.last_publication_date = moment(j.last_publication_date)

        if (j.contract_type_abbreviation && j.contract_type_abbreviation !== "" && !typeContratTmp.includes(j.contract_type_abbreviation)) {
            typeContratTmp.push(j.contract_type_abbreviation)
            typeContrat.push(createOption(j.contract_type_abbreviation))
        }
        if (j.type_de_poste && j.type_de_poste !== "" && !metierTmp.includes(j.type_de_poste)) {
            metierTmp.push(j.type_de_poste)
            metier.push(createOption(j.type_de_poste))
        }
        // if (j.localisation && j.localisation !== "" && !localisationTmp.includes(j.localisation) && j.localisation != "Ile-de-France") {
        //     localisationTmp.push(j.localisation)
        //     localisation.push(createOption(j.localisation))
        // }
        return null
    })

    typeContrat.sort(optionCompare)
    metier.sort(optionCompare)
    localisation.sort(optionCompare)

    return {
        typeContrat: typeContrat,
        metier: metier,
        localisation: localisation,
    }
}

function testFilter(j, field, filter) {
    if (filter == null) {
        return true
    } else if (field === "localisation") {
        let localisationsTests = {
            "75 - Paris": "Paris - 12 ème (Siège social)",
            // "77 - Seine-et-Marne": "Ile-de-France",
            "78 - Yvelines": "Ile-de-France",
            "91 - Essonne": "Ile-de-France",
            "92 - Hauts-de-Seine": "Ile-de-France",
            "93 - Seine Saint-Denis": "Ile-de-France",
            "94 - Val-de-Marne": "Ile-de-France",
            "95 - Val-d'Oise": "Ile-de-France",
        }
        // console.log("field", field, filter, localisationsTests[j[field]])

        if (filter.value == "75 - Paris" && j[field] == "Ile-de-France") {
            return true
        }

        return j[field] == filter.value || j[field] == localisationsTests[filter.value]
    } else if (field === "text") {
        if (filter.value == "Réseau d'agences" && !j.isSiegeSocial) {
            return true
        } else if (filter.value == "Siège social" && j.isSiegeSocial) {
            return true
        }
        let text = j.title + " " + j.profile_description + " " + j.position_description + " " + j.employer_description
        text = text
            .toUpperCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
        return text.includes(
            filter.value
                .toUpperCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
        )
    } else {
        return j[field] == filter.value
    }
}

function getResultFilter(filters, excludedId) {
    let res = []
    jobaffinity.jobs.map((j) => {
        let flag = true
        Object.keys(filters).map((field) => {
            if (Array.isArray(filters[field])) {
                let flagFilter = field == "text" || filters[field].length == 0
                filters[field].map((filter) => {
                    if (field == "text") {
                        flagFilter = flagFilter && testFilter(j, field, filter)
                    } else {
                        flagFilter = flagFilter || testFilter(j, field, filter)
                    }
                })
                flag = flag && flagFilter
            } else {
                flag = flag && testFilter(j, field, filters[field])
            }
        })

        if (flag && j.id != excludedId) {
            res.push(j)
        }
    })
    res.sort(publicationDateCompare)
    return res
}

function getSimilarJob(job) {
    let filters = {
        contract_type_abbreviation: [
            {
                value: job.contract_type_abbreviation,
                label: job.contract_type_abbreviation,
            },
        ],
        type_de_poste: [
            {
                value: job.type_de_poste,
                label: job.type_de_poste,
            },
        ],
    }
    return getResultFilter(filters, job.id)
}

// function initATInternet() {
//     if (typeof window.ATInternet !== "undefined") {
//         window.tag = new window.ATInternet.Tracker.Tag({ site: 602755 })
//     }
// }

function tag_offres_emplois() {
    // if (typeof window.tag === "undefined") {
    //     initATInternet()
    // }
    // if (typeof window.tag !== "undefined") {
        // window.tag.page.send({ name: "OFFRES_EMPLOIS" })
        // window.tag.dispatch()
        window.tc_vars = {}
        window.tc_vars.page_nom = "OFFRES_EMPLOIS"
    // }
}

function App() {
    const [results, setResults] = useState(jobaffinity.jobs)
    const [currentJob, setCurrentJob] = useState(firstJob)
    const [similar, setSimilar] = useState(firstSimilarJobs)
    const [updateId, setUpdateId] = useState(0)
    const [updateFilter, setUpdateFilter] = useState(0)

    let headerHtml = document.getElementById("toutes_offres_header").innerHTML
    let pageTitle = ""

    useEffect(() => {
        pageTitle = document.title

       

        window.onpopstate = function () {
            console.log("back", window.location.lasthash);
            // Vérifier l'URL pour un ID d'offre
            const urlParts = window.location.pathname.split("/");
            const lastUrlPart = urlParts[urlParts.length - 1];
            const jobId = /^\d{6}$/.test(lastUrlPart) ? lastUrlPart : null;
            console.log("🚀 ~ useEffect ~ jobId:", jobId);

            if (jobId) {
                const job = jobaffinity.jobs.find((j) => j.id == jobId);
                if (job) {
                    setCurrentJob(job);
                    setSimilar(getSimilarJob(job));
                }
            } else {
                setCurrentJob(null);
                tag_offres_emplois();
            }
        }

        // console.log("🚀 ~ file: App.js ~ line 92 ~ useEffect ~ pageTitle", pageTitle)
        // console.log("toutes_offres_header", document.querySelector("#toutes_offres_header").innerHTML)
        // console.log("searchPageHeader", document.querySelector("#searchPageHeader").innerHTML)
        setTimeout(() => {
            document.querySelector("#toutes_offres_header").innerHTML = document.querySelector("#searchPageHeader").innerHTML
        }, 2000)

        if (!firstJob) {
            tag_offres_emplois()
        }
    }, [])

    function applyFilter(filters) {
        console.log("🚀 ~ file: App.js ~ line 178 ~ applyFilter ~ filters", filters)
        let res = getResultFilter(filters)
        setResults(res)
        setUpdateId(updateId + 1)
    }

    function openJob(job) {
        // console.log("🚀 ~ file: App.js ~ line 114 ~ openJob ~ job", job, pageTitle)
        headerHtml = document.getElementById("searchPageHeader").innerHTML
        window.scrollTo(0, 0)
        if (currentJob && currentJob.id !== job.id && window.history.state == null) {
            window.history.pushState(
                { pageId: job.id },
                job.title,
                `../${job.id}`
            );
        } else {
            window.history.pushState({ pageId: job.id }, job.title, job.id);
        }

        let similarJobs = getSimilarJob(job).slice(0, 2)
        // console.log("🚀 ~ file: App.js ~ line 186 ~ openJob ~ similarJobs", similarJobs)
        setSimilar(similarJobs)
        setCurrentJob(job)
        setUpdateId(updateId + 1)
    }

    function closeJob(e) {
        e.preventDefault()
        setCurrentJob(null)

        tag_offres_emplois()

        if (window.history.state == null) {
            window.history.pushState({ pageId: null }, pageTitle, "../");
            firstJob = null;
        } else {
            window.history.back();
        }
    }

    let prepare_candidature = document.getElementById("prepare_candidature") ? document.getElementById("prepare_candidature").innerHTML : ""

    return (
        <div className="App">
            <div style={{ display: Boolean(currentJob) ? "none" : "block" }}>
                <div id="searchPageHeader" dangerouslySetInnerHTML={{ __html: headerHtml }}></div>
                <SearchFilters key={updateFilter} jobs={jobaffinity.jobs} applyFilter={applyFilter} {...filters} />
                <h2>{`${results.length} résultats`}</h2>
                <div className="u-background-darker" id="searchResult">
                    {results.length > 0 && <SearchResults key={updateId} results={results} openJob={openJob} />}
                    {results.length == 0 && (
                        <React.Fragment>
                            <div className="noresult">
                                <p>
                                    Votre recherche ne donne aucun résultat.
                                    <br />
                                    Entrez de nouveaux critères pour rafraichir les résultats
                                </p>
                                <a
                                    onClick={(e) => {
                                        e.preventDefault()
                                        applyFilter([])
                                        setUpdateFilter(updateFilter + 1)
                                    }}
                                    className="c-button c-button--red"
                                >
                                    Voir toutes nos offres
                                </a>
                            </div>
                            <div className="prepare-candidature" dangerouslySetInnerHTML={{ __html: prepare_candidature }}></div>
                        </React.Fragment>
                    )}
                </div>
            </div>
            {currentJob && (
                <React.Fragment>
                    <Job job={currentJob} closeJob={closeJob} />
                    {similar.length > 0 && (
                        <div className="u-background-darker offre-similar">
                            <h2>Ces offres pourraient vous intéresser</h2>
                            <SearchResults key={updateId} results={similar} openJob={openJob} nopage={true} />
                        </div>
                    )}
                    <div className="prepare-candidature" dangerouslySetInnerHTML={{ __html: prepare_candidature }}></div>
                </React.Fragment>
            )}
        </div>
    )
}

export default App
